var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.5209 104.44585",
    width: 151.5209,
    height: 104.44585,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs884"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style882"
  }, ".cls-1{fill:#3457a6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title886"
  }, "pixelcities_elements") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title886"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 63.93,60.645858 47.6,104.44586 c 0,0 48.94,-14.610002 54.3,-47.000002 5.36,-32.39 0.52,-50.3000003 16.54,-51.6400003 l 32.67,-1.93 a 0.48,0.48 0 0 0 0,-0.95 l -47,-2.89000001 c 0,0 -15.87,-1.06999999 -21,8.48000001 C 77.98,18.065858 63.93,60.645858 63.93,60.645858 Z",
    id: "path888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 59.91,40.325858 0,95.505858 c 0,0 40.42,6.000002 69.68,-20.92 29.26,-26.92 27.87,-53.66 27.87,-53.66 l -8.81,-9.52 z",
    id: "path890"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.201da622207e4be124f4fc24f431b854.svg";
export { ForwardRef as ReactComponent };